
const ShortcutLogo = () => {
  return (
<svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
>
    <rect x="2" y="2" width="20" height="20" stroke="black" stroke-width="2" fill="none"/>
    <path d="M10 14L14 10M14 10H10M14 10V14" stroke="black" stroke-width="2"/>
</svg>
  );
};

export default ShortcutLogo;
